import React from 'react';

import Text from '../Text';

export function CardTitle({ children = null }) {
  if (!children) return null;

  return (
    <Text type="h4" data-card-element="title">
      {children}
    </Text>
  );
}
